import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Hearts = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    key: "k0"
  }), React.createElement("path", {
    d: "M10.817 4.454l.183.175a6 6 0 0110.231 3.875 5.507 5.507 0 00-4.119.534L17 9.104l-.112-.067a5.5 5.5 0 00-6.605 8.673l2.302 2.304L11 21.6l-8.485-8.485a6 6 0 018.302-8.661zm11.486 6.893a3.5 3.5 0 010 4.95L17 21.6l-5.303-5.303a3.5 3.5 0 114.95-4.95L17 11.7l.354-.353a3.5 3.5 0 014.95 0z",
    key: "k1"
  }));
});
Hearts.displayName = 'Hearts';
export var HeartsDimensions = {
  height: 24,
  width: 24
};